<template>
	<div class="partners mt-5 mb-5">
		<h3 class="partners-title">
			{{ $t('We selected the best hotels for you') }}</h3>
		<ul class="partners-list">
			<li>
				<img alt="Booking.com" src="../../assets/partners/wh.svg">
			</li>
			<li>
				<img alt="Expedia" src="../../assets/partners/mi.svg">
			</li>
			<li>
				<img alt="Agoda" src="../../assets/partners/bw.svg">
			</li>
			<li>
				<img alt="Hotels.com" src="../../assets/partners/hw.svg">
			</li>
			<li class="partners-more">
				{{ $t('+ millions more') }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
  name: 'Partners',
}
</script>

<style scoped>
	.partners-title{
		margin-top:0;
		margin-bottom:10px;
	}
	.partners-list{
		list-style:none;
		padding:0;
	}
	.partners-list li{
		display:inline-block;
		width:50%;
		text-align:center;
		margin-bottom:20px;
	}
	.partners-list li img{
		max-width:150px;
		max-height:30px;
	}
	.partners-list li.partners-more{
		width:100%;
	}
	.partners{
		margin-top:25px;
	}
	.partners h3{
		font-size:16px;
		text-align:center;
		margin-bottom:25px;
	}
	@media screen and (min-width: 768px) {
		.partners-list li,
		.partners-list li.partners-more{
			width:33%;
		}
	}
	@media screen and (min-width: 992px) {
		.partners-list li,
		.partners-list li.partners-more{
			width:20%;
		}
	}
</style>